import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Backdrop, Block, Overlay, Portal } from "reakit";
import { Box, Button, Flex, Image, Text } from "rebass";
import { FloatingButton } from "../Base/Buttons";
import { PositionBox } from "../Base";
import check from "../../resources/img/icons/Checkbox@1x.png";
import IosClose from "react-ionicons/lib/IosClose";

import { returnFacultyFilterString } from "../../utils";
import Filters from "./Filters";
import StudentFilters from "./StudentFilters";
import { schoolSelectors } from "../../store/school";
import { authSelectors } from "../../store/auth";
import { searchSelectors } from "../../store/search";

import { Arrow, FilterOverlay, HeaderWrapper, Title } from "./styles";

class ApplyFilter extends Component {
  render() {
    const {
      clearFilter,
      school,
      isCheckin,
      checkinFilters,
      title,
    } = this.props;

    const {
      isNew,
      updateFilters,
      isHealth,
    } = this.props;

    const { history } = this.props;
    let { filters } = this.props;
    if (!filters.type) {
      let newfilters = {
        ...filters,
        type: [],
      };
      filters = newfilters;
    }

    const newFilterTitle = (title) => {
      let newText = "";

      if (newText === ", " || newText === "") {
        return title;
      } else {
        if (title === "All Faculties") {
          return newText.substr(2);
        } else {
          return title + newText;
        }
      }
    };

    let filterTitle = returnFacultyFilterString(filters);

    const newClearFilter = () => {
      clearFilter();
    };

    return (
      <Overlay.Container>
        {(overlay) => (
          <Block>
            <Flex {...overlay} onClick={overlay.show}>
              <Box>
                <Text color="#969a9b" fontWeight={600}>
                  {isCheckin || isHealth ? title : newFilterTitle(filterTitle)}
                </Text>
              </Box>
              <Box>
                <Arrow color={"#969a9b"} fontSize={"17px"} />
              </Box>
            </Flex>
            <Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
            <FilterOverlay use={Portal} {...overlay} padding={0} margin={0}>
              <FloatingButton
                bg={"purple"}
                onClick={() => {
                  overlay.hide();
                }}
              >
                <Image src={check} />
              </FloatingButton>
              <Box>
                <HeaderWrapper>
                  <Flex>
                    <Box>
                      <IosClose
                        onClick={() => {
                          overlay.hide();
                        }}
                        fontSize={"40px"}
                        color={"black"}
                      />
                    </Box>
                    <Box mr={"auto"} />
                    <Box>
                      <Button
                        onClick={() => {
                          newClearFilter();
                          overlay.hide();
                        }}
                      >
                        Clear
                      </Button>
                    </Box>
                  </Flex>
                  <Title>Filters</Title>
                </HeaderWrapper>

                <Block>
                  <PositionBox position={["relative", "default"]} top={"-40px"}>
                    {isNew ? (
                      <StudentFilters
                        handleUpdate={updateFilters}
                        filters={filters}
                        isCheckin={isCheckin}
                        checkinFilters={checkinFilters}
                      />
                    ) : (
                      <Filters
                        {...this.props}
                        isCheckin={isCheckin}
                        checkinFilters={checkinFilters}
                        history={history}
                      />
                    )}
                  </PositionBox>
                </Block>
              </Box>
            </FilterOverlay>
          </Block>
        )}
      </Overlay.Container>
    );
  }
}

ApplyFilter.propTypes = {
  isCheckin: PropTypes.bool,
  title: PropTypes.string,
  isNew: PropTypes.bool,
};

ApplyFilter.defaultProps = {
  isCheckin: false,
  checkinFilters: [],
  title: "Apply Filters",
  isNew: false,
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  profileInfo: authSelectors.refreshProfile(state.auth),
  loading: authSelectors.isLoading(state.auth),
  searchFilters: searchSelectors.refreshFilters(state.searchFaculty),
  extraCheckinFilters: searchSelectors.refreshCheckinFilters(state.searchFaculty),
  isLoading: schoolSelectors.isLoading(state.school),
});

const mapDispatchToProps = () => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplyFilter);
